module.exports = __webpack_public_path__ + "static/media/crossp.e4c3c7a5.png";